const turf = require("@turf/turf");


// Function to extract unique values from a GeoJSON object based on a specified property
export async function getUniqueValuesGeoJsonField(geojson, property) {
  const uniqueValues = new Set();

  turf.meta.coordEach(geojson, (coord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) => {
    const value = geojson.features[featureIndex].properties[property];
    uniqueValues.add(value);
  });

  return Array.from(uniqueValues);
}

export function parseGeoJsonList(geoJsonString) {
  const geoJsonList = geoJsonString.replace(/[()]/g, '').split(',').map(Number);
  return geoJsonList;
}

export function getKeyForValue(value, dictionary) {
  for (const [key, dictValue] of Object.entries(dictionary)) {
    if (value === dictValue) {
      return key;
    }
  }
  // Handle case where value is not found in dictionary
  console.warn(`Value '${value}' not found in dictionary.`);
  return null;
}

function deletePropertiesFromArray(arr, keys) {
  return arr.filter(item => !keys.includes(item));
}

export function makeSelectorToGeoJsonNamesDict(userGroup) {

  const selectorToGeoJsonNamesDict = {
    // "Whole Plant Health Overall": "health_overall",
    // "Canopy Health Overall": "canopy_health_overall",
    // "Fruit Health Overall": "fruit_health_overall",
    // "Vine Health Overall": "vine_health_overall",
    'Height (in.)': "canopy_height_0d",
    'Density (%)': "canopy_density_0d",
    'Volume Index': "canopy_volume_index_0d",
    'Shoot Length Avg. (in.)': "shoot_length_avg",
    'Shoot Length Max. (in.)': "shoot_length_max",
    'Shoot Length Min. (in.)': "shoot_length_min",
    'Shoot Height Avg. (in.)': "shoot_height_avg",
    'Shoot Height Max. (in.)': "shoot_height_max",
    'Shoot Height Min. (in.)': "shoot_height_min",
    'Shoot Count': "shoot_count",
    // 'Shoot Angle Avg. (deg.)': "shoot_angle_avg",
    // 'Shoot Angle Max (deg.)': "shoot_angle_max",
    "Trunk thickness (in.)": "trunk_thickness_inches",
  };

  if (userGroup === 'kiatra' || userGroup === 'harlan_estate' || userGroup === 'mayacamas' || userGroup ==='ej_gallo' || userGroup === 'harlan_estate-dev' || userGroup === 'renteria' || userGroup === '4_Winds' || userGroup === 'eisele_vineyard' | userGroup === 'steltzner'){
    selectorToGeoJsonNamesDict['Cluster count'] = "cluster_count";
    selectorToGeoJsonNamesDict['Cluster size index'] = "cluster_areas_avg";
    selectorToGeoJsonNamesDict['Cluster length avg. (in.)'] = "cluster_heights_avg";
    selectorToGeoJsonNamesDict['Cluster width avg. (in.)'] = "cluster_widths_avg";
    selectorToGeoJsonNamesDict['Yield index'] = "yield_index";
    selectorToGeoJsonNamesDict['Clusters per shoot'] = "clusters_per_shoot";
    selectorToGeoJsonNamesDict['Yield per canopy volume'] = "yield_per_canopy_volume";
  };

  if (userGroup === 'renteria' | userGroup === 'kiatra' | userGroup === 'harlan_estate' | userGroup === 'mayacamas' | userGroup === 'steltzner' | userGroup === '4_Winds'){
    selectorToGeoJsonNamesDict['Percent veraison'] = "percent_veraison";
  }

  // if (userGroup === 'kiatra' || userGroup === 'harlan_estate' || userGroup === 'mayacamas' || userGroup ==='ej_gallo'){
  //   selectorToGeoJsonNamesDict['Cluster size index'] = "cluster_areas_avg";
  //   selectorToGeoJsonNamesDict['Cluster length avg. (in.)'] = "cluster_heights_avg";
  //   selectorToGeoJsonNamesDict['Cluster width avg. (in.)'] = "cluster_widths_avg";
  // }

  if (userGroup === 'harlan_estate'){
    selectorToGeoJsonNamesDict['Spur Count'] = "spur_count";
    selectorToGeoJsonNamesDict['Spur Height Avg. (in.)'] = "spur_height_avg";
    selectorToGeoJsonNamesDict['Fraction Trellis Region Avg.'] = "avg_percent_trellis";
  };

  return selectorToGeoJsonNamesDict;
};

export function makeMetricsByInsightCategoryDict(userGroup) {
  const insightMetricsByCategoryDict = {
    // "Whole Plant Health": [
    //   "Whole Plant Health Overall"
    // ],
    "Canopy Health": [
      // "Canopy Health Overall", 
      "Volume Index",
      "Shoot Length Avg. (in.)",
      "Shoot Length Max. (in.)",
      "Shoot Length Min. (in.)",
      "Shoot Height Avg. (in.)",
      "Shoot Height Max. (in.)",
      "Shoot Height Min. (in.)",
      // 'Shoot Angle Avg. (deg.)',
      // 'Shoot Angle Max (deg.)',
      "Shoot Count",
      // "Height (in.)", 
      "Density (%)"
    ],
    "Vine Health": [
      // "Vine Health Overall", 
      "Trunk thickness (in.)"
    ],
  };

  if (userGroup === 'acierno') {
    delete insightMetricsByCategoryDict["Canopy Health"];
  };

  if (userGroup === 'kiatra' || userGroup === 'harlan_estate' || userGroup === 'mayacamas' || userGroup ==='ej_gallo' || userGroup === 'harlan_estate-dev' || userGroup === 'renteria' || userGroup === '4_Winds' || userGroup === 'eisele_vineyard' | userGroup === 'steltzner'){
    insightMetricsByCategoryDict["Fruit Health"] = [];
    insightMetricsByCategoryDict["Fruit Health"].push(
      // "Fruit Health Overall",
      "Cluster count",
      "Cluster size index",
      "Cluster length avg. (in.)",
      "Cluster width avg. (in.)",
      "Yield index",
      "Clusters per shoot",
      "Yield per canopy volume"
    );
    if (userGroup === 'renteria' | userGroup === 'kiatra' | userGroup === 'harlan_estate' | userGroup === 'mayacamas' | userGroup === 'steltzner' | userGroup === '4_Winds') {
      insightMetricsByCategoryDict["Fruit Health"].push(
        "Percent veraison"
      )
    }
  };

  // if(userGroup === '4_Winds'){
  //   console.log('userGroup in DataPrep:', userGroup);
  //   console.log('insightMetricsByCategoryDict before delete', insightMetricsByCategoryDict);
    
  //   insightMetricsByCategoryDict['Canopy Health'] = deletePropertiesFromArray(insightMetricsByCategoryDict['Canopy Health'], [
  //     "Shoot Length Avg. (in.)",
  //     "Shoot Length Max. (in.)",
  //     "Shoot Length Min. (in.)",
  //     "Shoot Height Avg. (in.)",
  //     "Shoot Height Max. (in.)",
  //     "Shoot Height Min. (in.)",
  //     "Shoot Count",
  //   ]);

  //   insightMetricsByCategoryDict["Fruit Health"] = deletePropertiesFromArray(insightMetricsByCategoryDict["Fruit Health"], [
  //     "Clusters per shoot",
  //   ]);

  //   console.log('insightMetricsByCategoryDict after delete', insightMetricsByCategoryDict);
  // }

  if (userGroup === 'harlan_estate' || userGroup === 'harlan_estate-dev'){
    insightMetricsByCategoryDict["Vine Health"].push(
      "Spur Count",
      "Spur Height Avg. (in.)"
    );
    insightMetricsByCategoryDict["Canopy Health"].push(
      "Fraction Trellis Region Avg."
    );
  };

  return insightMetricsByCategoryDict;
}